export default __webpack_public_path__ + "static/media/640_dummy2016-kunstgalerie01-de.a341d687.png";